// Standalone SVG, one file per toast state. Uses currentColor so the SCSS
// (via --toast-accent) drives the colour — never hardcode a colour here.
const SuccessIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 10.5 L8.3 15 L16 5.5" />
  </svg>
)

export default SuccessIcon
